import * as $ from 'jquery';
import mapStyles from '../../../js/mapStyles';
import store from '../../../js/store';

const markerTypes = ['plain','clinic','hospital'];

let maps = {},
    autoComplete = [],
    api;

const $directionsGeolocation = $('.directions-form .current-location'),
      $clinicSearchInput     = $('.clinic-search__input');

const directionsGeo = (function() {
  if(!$directionsGeolocation.length || !'geolocation' in navigator) {
    return false;
  }

  const geocoder = new api.Geocoder();

  $directionsGeolocation
    .removeClass('hidden')
    .on('click', function(e) {
      e.preventDefault();

      const $btn = $(this)
      $btn.addClass('loading')

      navigator.geolocation.getCurrentPosition(position => {

        const geocoder = new api.Geocoder
        const latLng = getLatLngFromGeolocation(position)

        geocoder.geocode({location: latLng}, results => {
          $btn.removeClass('loading')
          if(!results.length) return

          const address = results[0].formatted_address
          $btn.siblings('.clinic-search__input').val(address);
          $btn.closest('form').submit();
        })
      }, () => {
        alert('An error occurred getting your location');
        $btn.removeClass('loading');
      });
    });
})

const addEvent = (function(elem) {
  var i = autoComplete.length;

  autoComplete[i] = new api.places.Autocomplete(elem, {
    componentRestrictions: {
      country: 'gb'
    }
  });
});


if(typeof window.google === 'object' && typeof window.google.maps === 'object') {
  api = window.google.maps;

  $('.map').each(function() {
    const $this = $(this),
          $marker = $('.map__marker', $this),
          mapId = $this.attr('id');

    const lat = parseFloat($marker.attr('data-lat')),
          lng = parseFloat($marker.attr('data-lng')),
          type = $marker.attr('data-marker');

    var $popover = $('.map__popover', $marker);

    if($popover.length) {

      var infoWindow = new google.maps.InfoWindow({
        content: $popover.html()
      });
    }

    var latLng = new api.LatLng({lat, lng})

    maps[mapId] = new api.Map(this, {
      center: latLng,
      zoom: 12,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      responsive: true,
      styles: mapStyles
    });

    const icon = {
      url: `/app/themes/madebrave/static/marker-red-${type}@2x.png`,
      scaledSize: new api.Size(42, 54),
      anchor: new api.Point(21, 48)
    }

    var map = maps[mapId];
    var marker = new api.Marker({map, icon, position: latLng});

    $this.closest('.tab__item').on('accordion-show', () => {
      api.event.trigger(map, 'resize');
      map.setCenter(latLng);
    });

  if (typeof(infoWindow) !== 'undefined') {
    infoWindow.open(maps[mapId], marker);

    api.event.addListener(infoWindow, 'domready', function() {
      const iwOuter = $('.gm-style-iw'),
            iwBg    = iwOuter.prev(),
            iwClose = iwOuter.next();

      $('.gm-style-iw').children().css({
         'vertical-align': 'middle',
      });

      iwBg.addClass('iwBackground');
      iwClose.addClass('iwClose');
    });
  }

  });


  $('.directions-form').on('submit', function(e) {
    e.preventDefault();

    const $form = $(this),
          data = $form.serialize(),
          url  = $form.attr('action');

    window.open(`${url}?${data}`, 'get-directions', 'directories=0,height=768,width=768,location=0,menubar=0,resizable=1,scrollbars=1,toolbar=0');
  });

  directionsGeo();



  $clinicSearchInput.each((i, elem) => {
    addEvent(elem);
  });
}
